<!--
상품 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xlarge">

            <div class="uk-modal-header">
                <h4>새 검수요청사항 작성</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <app-input-ex
                    class="uk-margin-small-bottom"
                    type="textarea"
                    input-size="small"
                    :textarea-rows="3"

                    name="request"
                    v-model="inputs.request"
                    label="검수요청사항"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"

                    placeholder="작업자에게 전달할 내용을 이해하기 쉽게 작성하세요"
                > </app-input-ex>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    작성완료
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            // 상품ID
            prodId: Number,
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    request: null,
                },
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form() {

                // 폼띄우기
                this.displayForm();
            },


            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/check-requests',
                    data: _.merge({
                        '_token': this.csrfToken,
                        'prod_id': this.prodId,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>